<span class="mo-selector-option-container" [class]="containerClass">
  <tc-master-operator-connect-indicator
    *ngIf="!hideConnect"
    [instance]="instance"
    [snapshot]="snapshot"
  ></tc-master-operator-connect-indicator>
  <span class="snapshot-pill"
    >{{ snapshotLabel }}
    <span *ngIf="snapshot?.endDate">
      {{ snapshot?.endDate | date }}
    </span></span
  >
  <tc-mo-connect-form-instance-option
    [hideConnect]="true"
    [instance]="instance"
    [containerClass]="containerClass"
  ></tc-mo-connect-form-instance-option>
</span>
